/** The game screen (HUD, notices, chat lines), the tutorial, character select and play/index.html. */
export default {
  "Your Speed Scroll is running: no run skills until it ends":
    "Hız Kağıdın etkin: bitene kadar koşu yetenekleri kullanılamaz",
  // ---- hud.ts: skill errors
  "Not enough MP": "Yeterli MP yok",
  "Out of range": "Menzil dışında",
  "No target": "Hedef yok",
  "Invalid target": "Geçersiz hedef",
  "Not ready yet": "Henüz hazır değil",
  "Already casting": "Zaten büyü yapıyorsun",
  "Can't do that now": "Şu an bunu yapamazsın",
  "Skill not learned": "Yetenek öğrenilmedi",
  "You are dead": "Öldün",

  // ---- hud.ts: notices
  "No one to talk to here": "Burada konuşacak kimse yok",
  "They don't do that": "Bu hizmeti vermiyorlar",
  "Not for sale": "Satılık değil",
  "Not enough gold": "Yeterli altın yok",
  "Not enough National Points": "Yeterli Ulusal Puan (NP) yok",
  "They won't buy that": "Bunu satın almıyorlar",
  "That can't be upgraded": "Bu eşya yükseltilemez",
  "It can't go any higher yet": "Şimdilik daha fazla yükseltilemez",
  "You need the right upgrade scroll": "Doğru yükseltme kağıdı gerekiyor",
  "Nothing there": "Orada bir şey yok",
  "Your bag is full": "Çantan dolu",
  "Too far away": "Çok uzak",
  "That loot belongs to someone else for now": "Bu ganimet şimdilik başkasına ait",
  "Nothing to pick up": "Alınacak bir şey yok",
  "No monster nearby": "Yakında canavar yok",
  "Already on your way to town": "Zaten kasabaya dönüyorsun",
  "Return to town interrupted": "Kasabaya dönüş kesildi",
  "It doesn't go there": "Oraya takılmaz",
  "Your class can't use that": "Sınıfın bunu kullanamaz",
  "A two-handed weapon leaves no hand for a shield": "İki elli silah kalkana el bırakmaz",
  "That scroll is still working. Wait until its hour is up":
    "Bu kağıdın etkisi sürüyor. Süresi dolana kadar bekle",
  "Your level is too low": "Seviyen çok düşük",
  "That can't be equipped": "Bu kuşanılamaz",
  "That can't be used": "Bu kullanılamaz",
  "Slow down, one message per second": "Yavaş ol, saniyede bir mesaj",
  "Your clan's grade is too low for this": "Klanının derecesi bunun için çok düşük",
  "No player by that name is online": "Bu isimde çevrimiçi oyuncu yok",
  "Chat and parties are unavailable for a moment, try again":
    "Sohbet ve partiler şu an kullanılamıyor, tekrar dene",
  "Jewelry is not rolled: merge three identical pieces instead":
    "Takılar yükseltilmez: bunun yerine üç aynı parçayı birleştir",
  "You need three of this piece at the same + level":
    "Bu parçadan aynı + seviyede üç tane gerekiyor",
  "You cannot whisper to yourself": "Kendine fısıltı gönderemezsin",
  "You can't invite yourself": "Kendini davet edemezsin",
  "Only players of your nation": "Sadece kendi ulusundan oyuncular",
  "No such quest": "Böyle bir görev yok",
  "Your level is too low for this quest": "Seviyen bu görev için çok düşük",
  "That quest is for the other nation": "Bu görev diğer ulusa ait",
  "You already have this quest": "Bu görev zaten sende",
  "You have finished this quest": "Bu görevi bitirdin",
  "Done for today. It comes back at midnight": "Bugünlük bitti. Gece yarısı yenilenir",
  "Your quest log is full": "Görev listen dolu",
  "You do not have this quest": "Bu görev sende değil",
  "This quest is not finished yet": "Bu görev henüz bitmedi",
  "The Rift Gate is closed. It opens at 16:00 and 20:30":
    "Rift Kapısı kapalı. 16:00 ve 20:30'da açılır",
  "Your time in the Rift is up for this opening": "Bu açılış için Rift'teki süren doldu",
  "Morgard opens only during the war (Wednesdays and Saturdays at 21:00)":
    "Morgard yalnızca savaş sırasında açılır (Çarşamba ve Cumartesi 21:00)",
  "The Colony is closed while the war of Morgard is on": "Morgard savaşı sürerken Colony kapalıdır",
  "The war of Morgard is over: back to Emberfold": "Morgard savaşı bitti: Emberfold'a dönüş",
  "You have no Riftstone of that color": "O renkte Riftstone'un yok",
  "They are already in a party": "Zaten bir partideler",
  "The party is full": "Parti dolu",
  "Only the party leader can do that": "Bunu sadece parti lideri yapabilir",
  "You are not in a party": "Bir partide değilsin",
  "That invite has expired": "Davetin süresi doldu",
  "Your invite was declined": "Davetin reddedildi",
  "Already in a clan": "Zaten bir klanda",
  "The clan is full": "Klan dolu",
  "You are not in a clan": "Bir klanda değilsin",
  "Your clan rank can't do that": "Klan rütben bunu yapmaya yetmiyor",
  "That clan name is taken": "Bu klan adı alınmış",
  "Clan names use letters, digits and single spaces":
    "Klan adları harf, rakam ve tek boşluk içerebilir",
  "The clan has as many officers as it can": "Klanın subay sayısı dolu",
  "Hand the clan to someone else first, or disband it":
    "Önce klanı başka birine devret ya da dağıt",
  "No clan member by that name": "Bu isimde klan üyesi yok",
  "No character by that name": "Bu isimde karakter yok",
  "You cannot add yourself": "Kendini ekleyemezsin",
  "Already on your friend list": "Zaten arkadaş listende",
  "Your friend list is full": "Arkadaş listen dolu",
  "Not on your friend list": "Arkadaş listende değil",
  "Purchase complete": "Satın alma tamamlandı",
  "Finish your trade first": "Önce takası bitir",
  "You already have a stall open: click it to see it or close it":
    "Zaten açık bir tezgâhın var: görmek ya da kapatmak için ona tıkla",
  "You can't buy from your own stall": "Kendi tezgâhından satın alamazsın",
  "You are muted and can't chat right now": "Susturuldun, şu an sohbet edemezsin",
  "Stalls can only be set up inside a town": "Tezgâh sadece kasaba içinde kurulabilir",
  "Not while fighting": "Savaşırken olmaz",
  "Add at least one item": "En az bir eşya ekle",
  "Too many items": "Çok fazla eşya",
  "Enter a price between 1 and 2,100,000,000": "1 ile 2.100.000.000 arasında bir fiyat gir",
  "That item is no longer in your bag": "Bu eşya artık çantanda değil",
  "That item can't be traded": "Bu eşya takas edilemez",
  "That stall is closed": "Bu tezgâh kapalı",
  "Someone bought it first": "Başkası senden önce aldı",
  "You can't carry more than 2,100,000,000 gold": "2.100.000.000 altından fazlasını taşıyamazsın",
  "They can't carry that much gold": "O kadar altın taşıyamazlar",
  "Their bag is full": "Onların çantası dolu",
  "You can't trade with yourself": "Kendinle takas yapamazsın",
  "No trade is open": "Açık takas yok",
  "Trade complete": "Takas tamamlandı",
  "Your warehouse is full": "Deponu dolu",
  "Purchase complete: it is in your bag": "Satın alma tamamlandı: çantanda",
  "Not enough gems": "Yeterli elmas yok",
  "You already own that": "Buna zaten sahipsin",
  "Gem packs are coming soon": "Elmas paketleri yakında geliyor",
  "You don't own that": "Buna sahip değilsin",
  "Items from the Power Up Store cannot be thrown away": "Power Up Mağazası eşyaları atılamaz",

  "Share my character": "Karakterimi paylaş",
  "My character in WarCrest Online": "WarCrest Online'daki karakterim",
  "Link copied: paste it anywhere to show your character":
    "Link kopyalandı: karakterini göstermek için istediğin yere yapıştır",
  "The link could not be copied": "Link kopyalanamadı",
  "Confirm your email first: your profile on the website sends the link again":
    "Önce e-postanı doğrula: web sitesindeki profilin bağlantıyı yeniden gönderir",
  "The purchase did not go through: try again in a moment":
    "Satın alma gerçekleşmedi: biraz sonra tekrar dene",
  "Purchases are turned off on this device (Screen Time)":
    "Bu cihazda satın alma kapalı (Ekran Süresi)",
  "The purchase waits for approval: your gems arrive once it is approved":
    "Satın alma onay bekliyor: onaylanınca elmasların gelir",
  "Payment done: your gems arrive in a few seconds":
    "Ödeme tamam: elmasların birkaç saniye içinde gelir",
  "The payment page could not be opened: try again in a moment":
    "Ödeme sayfası açılamadı: biraz sonra yeniden dene",
  "You pay through the App Store. Your gems arrive a few seconds after the payment.":
    "Ödemeyi App Store üzerinden yaparsın. Elmasların ödemeden birkaç saniye sonra gelir.",
  "You pay on Polar's secure page, which opens in a new tab. Your gems arrive as soon as the payment is done.":
    "Ödemeyi yeni sekmede açılan Polar'ın güvenli sayfasında yaparsın. Ödeme biter bitmez elmasların gelir.",
  "Your character pages are off: turn them on in your profile to share":
    "Karakter sayfaların kapalı: paylaşmak için profilinden aç",
  "Invite reward: your scrolls are in your bag": "Davet ödülü: kağıtların çantanda",
  "A friend you invited is growing strong: your reward scrolls are in your bag":
    "Davet ettiğin arkadaşın güçleniyor: ödül kağıtların çantanda",
  "Make room in your bag: an invite reward is waiting":
    "Çantanda yer aç: bir davet ödülü seni bekliyor",
  // ---- hud.ts: frames, buffs, bars
  "max HP": "maks. HP",
  defense: "savunma",
  "attack power": "saldırı gücü",
  "move speed": "hareket hızı",
  "damage taken": "alınan hasar",
  XP: "XP",
  "loot gold": "ganimet altını",
  Stunned: "Sersem",
  Frozen: "Donmuş",
  Rooted: "Kök salmış",
  Slowed: "Yavaşlamış",
  Stealth: "Gizlenme",
  "1 unspent stat point": "1 harcanmamış stat puanı",
  "{n} unspent stat points": "{n} harcanmamış stat puanı",
  MAX: "MAKS",
  "Max level": "Maksimum seviye",
  "Level {level}": "Seviye {level}",
  "{m} min {s} s left": "{m} dk {s} sn kaldı",
  "Double-click to end it": "Bitirmek için çift tıkla",
  EVENT: "ETKİNLİK",
  "War of Morgard": "Morgard Savaşı",
  "Your nation won the last war: +{xp}% XP, +{gold}% gold and +{drop}% drops until the next war begins":
    "Ulusun son savaşı kazandı: bir sonraki savaş başlayana kadar +%{xp} XP, +%{gold} altın ve +%{drop} drop",
  "Victory bonus +{pct}%": "Zafer bonusu +%{pct}",
  "XP, gold, drops": "XP, altın, drop",
  "Rift Gate open": "Rift Kapısı açık",
  "XP +{pct}%": "XP +%{pct}",
  "Drop +{pct}%": "Drop +%{pct}",
  "Gold +{pct}%": "Altın +%{pct}",
  "Bonus events": "Bonus etkinlikler",
  // ---- ui/eventsWindow.ts: the event calendar
  Events: "Etkinlikler",
  "Times are on your own clock": "Saatler senin saatine göre",
  "{h} h {m} min left": "{h} sa {m} dk kaldı",
  "{m} min left": "{m} dk kaldı",
  "On now": "Şu an açık",
  "Lv {n}+ · {a} against {b} · {m} min": "Sv. {n}+ · {a} kişiye {b} kişi · {m} dk",
  "Sign-up open: join from the corner of the screen": "Kayıt açık: ekranın köşesinden katıl",
  "Lv {n}+ · the gate in the {zone} stays open {m} min":
    "Sv. {n}+ · {zone} içindeki kapı {m} dk açık kalır",
  "Lv {n}+ · nation against nation · {m} min": "Sv. {n}+ · ulus ulusa karşı · {m} dk",
  "New day": "Yeni gün",
  "Daily quests and the login reward start again": "Günlük görevler ve giriş ödülü yenilenir",
  "A bonus event for everyone on the server": "Sunucudaki herkes için bonus etkinliği",
  "Respawning in {n}s": "{n} sn içinde yeniden doğuluyor",

  // ---- game.ts
  Stall: "Tezgâh",
  "Sell items to players from a stall": "Eşyalarını tezgâhta oyunculara sat",
  "You are not in a party: switch to Global to talk to everyone.":
    "Bir partide değilsin: herkesle konuşmak için Genel'e geç.",
  "You are not in a clan: switch to Global to talk to everyone.":
    "Bir klanda değilsin: herkesle konuşmak için Genel'e geç.",
  "{name} wants to trade with you.": "{name} seninle takas yapmak istiyor.",
  "{name} is online.": "{name} çevrimiçi oldu.",
  "{name} went offline.": "{name} çevrimdışı oldu.",
  "{name} invites you to their party.": "{name} seni partisine davet ediyor.",
  "{name} invites you to the clan {clan}.": "{name} seni {clan} klanına davet ediyor.",
  Miss: "Iska",
  "Return to town": "Kasabaya dön",
  "{name} brought you to them": "{name} seni yanına çağırdı",
  "{name} brought you to them.": "{name} seni yanına çağırdı.",
  "Your party's mage brought you to them": "Partinin büyücüsü seni yanına çağırdı",
  "Your party's mage brought you to them.": "Partinin büyücüsü seni yanına çağırdı.",
  "The enemy base burns you: get out!": "Düşman üssü seni yakıyor: hemen çık!",
  Cleansed: "Arındın",
  "You left the world. Your character is saved.": "Dünyadan ayrıldın. Karakterin kaydedildi.",
  "Play again": "Tekrar oyna",
  "Rift closes for you in {time}": "Rift senin için {time} içinde kapanıyor",
  "/p text: party chat, /c text: clan chat, /g text: global chat":
    "/p metin: parti sohbeti, /c metin: klan sohbeti, /g metin: genel sohbet",
  "/w Name text: whisper, /r text: reply, /block Name, /unblock Name, /block: list":
    "/w İsim metin: fısıltı, /r metin: yanıtla, /block İsim, /unblock İsim, /block: liste",
  "/invite Name, /kick Name, /leave: party": "/invite İsim, /kick İsim, /leave: parti",
  "/cinvite Name, /cleave: clan (G opens the clan window)":
    "/cinvite İsim, /cleave: klan (G klan penceresini açar)",
  Gate: "Kapı",
  "Travel gate": "Yolculuk Kapısı",
  "Way back": "Dönüş Yolu",

  // ---- tutorial.ts
  "Find your feet": "Adımlarını at",
  "Move with <b>W A S D</b>. Drag with the mouse to look around.":
    "<b>W A S D</b> ile yürü. Etrafa bakmak için fareyle sürükle.",
  "Drag the <b>joystick</b> at the bottom left to move. Drag anywhere else to look around.":
    "Yürümek için sol alttaki <b>joystick</b>'i sürükle. Etrafa bakmak için başka bir yeri sürükle.",
  "Go hunting": "Avlanmaya çık",
  "Wild boars roam outside the gate. Follow the <b>gold arrow</b>.":
    "Yaban domuzları kapının dışında dolaşıyor. <b>Altın oku</b> takip et.",
  "Pick a fight": "Kavga başlat",
  "<b>Click</b> a boar, or press <b>R</b> to attack the nearest one.":
    "Bir domuza <b>tıkla</b> ya da en yakınına saldırmak için <b>R</b>'ye bas.",
  "<b>Tap</b> a boar, or the <b>sword button</b>, to attack.":
    "Saldırmak için bir domuza ya da <b>kılıç düğmesine</b> <b>dokun</b>.",
  "Bring it down": "Yere ser",
  "You attack on your own while it is your target. Stay close until it falls.":
    "Hedefin olduğu sürece kendiliğinden saldırırsın. Düşene kadar yakın dur.",
  "Take the spoils": "Ganimeti al",
  "It dropped a chest. <b>Click</b> it, or press <b>F</b> next to it.":
    "Bir sandık düşürdü. Ona <b>tıkla</b> ya da yanındayken <b>F</b>'ye bas.",
  "It dropped a chest. <b>Tap</b> it to pick up what is inside.":
    "Bir sandık düşürdü. İçindekileri almak için ona <b>dokun</b>.",
  "Use a skill": "Bir yetenek kullan",
  "Press <b>1</b> in a fight: your first skill hits harder than a swing.":
    "Dövüşte <b>1</b>'e bas: ilk yeteneğin normal vuruştan daha sert vurur.",
  "Tap the <b>first skill</b> in your bar during a fight.":
    "Dövüş sırasında çubuğundaki <b>ilk yeteneğe</b> dokun.",
  "Know the town": "Kasabayı tanı",
  "The glowing symbols over townsfolk show what they sell or do. Press <b>M</b> for the map.":
    "Kasabalıların üstündeki parlayan simgeler ne sattıklarını ya da ne yaptıklarını gösterir. Harita için <b>M</b>'ye bas.",
  "The glowing symbols over townsfolk show what they sell or do. Tap the <b>minimap</b> for the map.":
    "Kasabalıların üstündeki parlayan simgeler ne sattıklarını ya da ne yaptıklarını gösterir. Harita için <b>mini haritaya</b> dokun.",
  "Welcome to {zone}, {name}.": "{zone} bölgesine hoş geldin, {name}.",
  "First steps {n}/{total}": "İlk adımlar {n}/{total}",
  "Hide tips": "İpuçlarını gizle",

  // ---- charSelect.ts
  "Front-line tank. Cleaves, stuns and taunts.": "Ön cephe tankı. Yarar, sersemletir ve kışkırtır.",
  "Burst damage. Poison, stealth and ambush.": "Ani yüksek hasar. Zehir, gizlenme ve pusu.",
  "Ranged caster. Fire, frost and Blink.": "Uzak menzilli büyücü. Ateş, buz ve Işınlanma.",
  "Healer. Mend, Prayer of Healing and Cure All.": "Şifacı. Onarma, Şifa Duası ve Tam Arınma.",
  "Tank, melee": "Tank, yakın dövüş",
  "Damage, melee": "Hasar, yakın dövüş",
  "Damage, ranged": "Hasar, uzak menzil",
  "Healer, ranged": "Şifacı, uzak menzil",
  Human: "İnsan",
  Orc: "Ork",
  Male: "Erkek",
  Female: "Kadın",
  "That name is already taken.": "Bu isim zaten alınmış.",
  "You already have 5 characters.": "Zaten 5 karakterin var.",
  "Entering the world...": "Dünyaya giriliyor...",
  "Crossing the gate...": "Geçitten geçiliyor...",
  "Potions never run out: drink red and blue as often as you need.":
    "İksirler hiç bitmez: kırmızıyı ve maviyi istediğin kadar iç.",
  "Gold Premium keeps your XP when a monster kills you.":
    "Gold Premium, bir canavar seni öldürdüğünde XP'ni korur.",
  "Defeating players of the other nation earns National Points (NP).":
    "Öteki ulusun oyuncularını yenmek Ulusal Puan (NP) kazandırır.",
  "Weapons glow from +7 and burn from +8.": "Silahlar +7'de parlamaya, +8'de yanmaya başlar.",
  "A party shares XP and loot, and every member adds a bonus.":
    "Parti XP'yi ve ganimeti paylaşır, her üye ayrıca bonus getirir.",
  "Open a stall in town to sell items even while you are offline.":
    "Kasabada tezgâh aç, çevrimdışıyken bile eşya sat.",
  "Win the war of Morgard and your whole nation gets a bonus.":
    "Morgard Savaşı'nı kazan, bütün ulusun bonus alsın.",
  "Buff scrolls last an hour and stay with you through death.":
    "Güçlendirme kağıtları bir saat sürer ve ölünce de seninle kalır.",
  "Names are 2-12 letters (A-Z) or digits, no spaces or symbols.":
    "İsimler 2-12 harf (A-Z) ya da rakamdan oluşur; boşluk ve simge olmaz.",
  "Something went wrong. Try again.": "Bir şeyler ters gitti. Tekrar dene.",
  "The name does not match.": "İsim eşleşmiyor.",
  "This character is still in the game. Log out first.": "Bu karakter hâlâ oyunda. Önce çıkış yap.",
  "This character has a stall open in town. Close it first.":
    "Bu karakterin kasabada açık bir tezgâhı var. Önce onu kapat.",
  "A clan leader cannot be deleted. Hand over or disband the clan first.":
    "Klan lideri silinemez. Önce klanı devret ya da dağıt.",
  "That character is already gone.": "Bu karakter zaten silinmiş.",
  "{race} {gender} {cls}": "{race} {gender} {cls}",
  "Lv {level}": "Sv {level}",
  "Crown of {nation}": "{nation} Tacı",
  "New character": "Yeni karakter",
  "Level {level} {cls}": "Seviye {level} {cls}",
  Nation: "Ulus",
  "Humans of Valcrest": "Valcrest İnsanları",
  "Orcs of Gorzhak": "Gorzhak Orkları",
  Role: "Rol",
  "Now in": "Şu an",
  "Create a character": "Karakter oluştur",
  "Empty slot": "Boş yuva",
  "Delete {name}, level {level} {cls}? Everything this character carries goes with it: items, gold, the warehouse and anything bought for it. This cannot be undone.":
    "{name} (seviye {level} {cls}) silinsin mi? Bu karakterin taşıdığı her şey onunla gider: eşyalar, altın, depo ve onun için alınan her şey. Bu işlem geri alınamaz.",

  // ---- main.ts
  "Account banned": "Hesap yasaklandı",
  "This account is banned until {date}.": "Bu hesap {date} tarihine kadar yasaklı.",
  "Too many characters": "Çok fazla karakter",
  "Another character of this account is already playing in another tab, window or device. Leave the game with it first.":
    "Bu hesabın başka bir karakteri şu an başka bir sekmede, pencerede ya da cihazda oyunda. Önce onunla oyundan çık.",
  Back: "Geri",
  "Could not connect: {error}": "Bağlanılamadı: {error}",
  "That channel just filled up. Pick another one.": "Bu kanal az önce doldu. Başka birini seç.",
  "Disconnected ({code}).": "Bağlantı kesildi ({code}).",
  "Removed by a GM": "Bir GM tarafından çıkarıldın",
  "A game master removed you from the game. Your character is saved.":
    "Bir oyun yöneticisi seni oyundan çıkardı. Karakterin kaydedildi.",
  Reconnect: "Yeniden bağlan",
  "Connection lost": "Bağlantı koptu",
  "Playing elsewhere": "Başka yerde oyunda",
  "This character entered the game from another window. Your character is saved.":
    "Bu karakter başka bir pencereden oyuna girdi. Karakterin kaydedildi.",
  "Reconnecting... Your character is saved.": "Yeniden bağlanılıyor... Karakterin kaydedildi.",
  "Chat always visible": "Sohbet hep görünür",
  "Off: it shows when you press Enter": "Kapalıyken Enter'a basınca görünür",
  "For full screen, tap Share in Safari, then Add to Home Screen.":
    "Tam ekran için Safari'de Paylaş'a, sonra Ana Ekrana Ekle'ye dokun.",
  "The connection to the server was lost. Your character is saved.":
    "Sunucuyla bağlantı koptu. Karakterin kaydedildi.",

  // ---- play/index.html
  "WarCrest Online: play": "WarCrest Online: Oyna",
  "You lead this party": "Bu partinin lideri sensin",
  "Active effects": "Aktif etkiler",
  "Invite to party": "Partiye davet et",
  Trade: "Takas",
  "Invite to clan": "Klana davet et",
  "Map (M)": "Harita (M)",
  "Game menu": "Oyun menüsü",
  "Frames per second": "Saniyedeki kare sayısı",
  "The war of Morgard: time left": "Morgard savaşı: kalan süre",
  "Game time": "Oyun saati",
  "Lock camera angle (L)": "Kamera açısını kilitle (L)",
  "Lock camera angle": "Kamera açısını kilitle",
  "M or Esc to close": "Kapatmak için M ya da Esc",
  You: "Sen",
  Players: "Oyuncular",
  Monsters: "Canavarlar",
  Loot: "Ganimet",
  Chat: "Sohbet",
  "Chat channel": "Sohbet kanalı",
  Global: "Genel",
  Party: "Parti",
  Clan: "Klan",
  "Say something to everyone": "Herkese bir şey söyle",
  "Chat message": "Sohbet mesajı",
  "Character and inventory": "Karakter ve çanta",
  "Character (C)": "Karakter (C)",
  Character: "Karakter",
  "Friends (O)": "Arkadaşlar (O)",
  Friends: "Arkadaşlar",
  "Skills (K)": "Yetenekler (K)",
  Skills: "Yetenekler",
  "Return to town (T)": "Kasabaya dön (T)",
  "Inventory (I)": "Çanta (I)",
  Inventory: "Çanta",
  "Power Up Store": "Power Up Mağazası",
  "Menu and settings (Esc)": "Menü ve ayarlar (Esc)",
  "Menu and settings": "Menü ve ayarlar",
  Attack: "Saldır",
  "+3 stat points": "+3 stat puanı",
  Experience: "Tecrübe",
  "You have fallen": "Öldün",
  "Change server": "Sunucu değiştir",
  "Your characters": "Karakterlerin",
  "Delete character": "Karakteri sil",
  "Type the name to confirm": "Onaylamak için ismi yaz",
  "Delete forever": "Kalıcı olarak sil",
  Gender: "Cinsiyet",
  Class: "Sınıf",
  Name: "İsim",
  "2-12 letters or digits": "2-12 harf ya da rakam",
  "Create and play": "Oluştur ve oyna",
  "Enter world": "Dünyaya gir",
  "Turn your screen to landscape": "Ekranını yatay çevir",
  "The game goes on behind this.": "Oyun arkada devam ediyor.",
  "Game masters cannot be whispered, invited or asked to trade":
    "Oyun yöneticilerine fısıltı, davet ya da takas isteği gönderilemez",
  // ---- the reward window (ui/rewardsWindow.ts) and its notices
  Rewards: "Ödüller",
  "Come back every day": "Her gün uğra",
  "Daily reward": "Günlük ödül",
  "First week": "İlk hafta",
  "Day {n}": "{n}. gün",
  Taken: "Alındı",
  "Claim day {n}": "{n}. günü al",
  "Next reward in {wait}": "Sonraki ödül {wait} sonra",
  "{m} min": "{m} dk",
  "{h} h {m} min": "{h} sa {m} dk",
  "Gold Premium, {n} day": "Gold Premium, {n} gün",
  "Premium {n}d": "Premium {n}g",
  "Game masters take no login rewards.": "Oyun yöneticileri giriş ödülü almaz.",
  "One reward a day for your account, in the bag of the character you play. A missed day is never lost: the next claim takes the next day.":
    "Hesabın için günde bir ödül, oynadığın karakterin çantasına gelir. Kaçırılan gün kaybolmaz: bir sonraki alışta sıradaki gün gelir.",
  "Reach level {n}": "{n}. seviyeye ulaş",
  "Hand in {n} quests": "{n} görev teslim et",
  "Join a party": "Bir partiye katıl",
  "Add a friend": "Bir arkadaş ekle",
  "Try an upgrade at a blacksmith": "Demircide bir yükseltme dene",
  "Goals for this character's first week.": "Bu karakterin ilk haftası için hedefler.",
  "Ends in {n} days": "{n} gün sonra biter",
  "Ends in {wait}": "{wait} sonra biter",
  "Daily reward taken: it is in your bag": "Günlük ödül alındı: çantanda",
  "Day 7 reward taken: the items are in your bag and Gold Premium runs a day longer":
    "7. gün ödülü alındı: eşyalar çantanda ve Gold Premium bir gün uzadı",
  "Day 7 reward taken: the items are in your bag, Gold Premium runs a day longer and the outfit is yours for a day: wear it from the store":
    "7. gün ödülü alındı: eşyalar çantanda, Gold Premium bir gün uzadı ve kostüm bir günlüğüne senin: mağazadan giyebilirsin",
  "{name}, {n} days": "{name}, {n} gün",
  "{name} armor, {n} day": "{name} zırhı, {n} gün",
  "Outfit {n}d": "Kostüm {n}g",
  "Today's reward is taken already. Come back tomorrow":
    "Bugünün ödülü zaten alındı. Yarın tekrar gel",
  "Goal reward taken: it is in your bag": "Hedef ödülü alındı: çantanda",
  "Reach the goal first": "Önce hedefe ulaş",
  "You took this reward already": "Bu ödülü zaten aldın",
  "Your first week is over": "İlk haftan bitti",
  "This goal is gone": "Bu hedef artık yok",
  // ---- game notifications (ui/gameMenu.ts)
  Notifications: "Bildirimler",
  "While you are away from the game": "Oyunda değilken",
  "In the evening, if you have not taken it": "Akşam, henüz almadıysan",
  "Ten minutes before it begins": "Başlamadan on dakika önce",
  "Rift Gate": "Rift Kapısı",
  "When the gate in the Bowl opens": "Bowl'daki kapı açıldığında",
  "XP, drop and gold events": "XP, drop ve altın etkinlikleri",
  "When a friend comes into the game": "Bir arkadaşın oyuna girdiğinde",
  "Stall sales": "Tezgâh satışları",
  "When your stall sells while you are away": "Sen yokken tezgâhın satış yaptığında",
  "On iPhone, notifications work in the app on your home screen: in Safari tap Share, then Add to Home Screen, and open the game from there.":
    "iPhone'da bildirimler ana ekrandaki uygulamada çalışır: Safari'de Paylaş'a, sonra Ana Ekrana Ekle'ye dokun ve oyunu oradan aç.",
  "This browser cannot show notifications.": "Bu tarayıcı bildirim gösteremiyor.",
  "Notifications are off for WarCrest: turn them on in your device's Settings.":
    "WarCrest bildirimleri kapalı: cihazının Ayarlar'ından aç.",
  "Notifications are blocked for this site: allow them in your browser's settings.":
    "Bu site için bildirimler engelli: tarayıcının ayarlarından izin ver.",
  "Notifications could not be turned on. Try again later.":
    "Bildirimler açılamadı. Daha sonra tekrar dene.",
  // ---- the mailbox (ui/mailWindow.ts) and feedback (ui/feedbackForm.ts)
  Mail: "Posta",
  "Letters from the WarCrest team": "WarCrest ekibinden mektuplar",
  "Mail: {n} new": "Posta: {n} yeni",
  "No letters.": "Mektup yok.",
  Gift: "Hediye",
  "Throw away": "Sil",
  "Take it within {n} days": "{n} gün içinde al",
  "A new letter is in your mail": "Postana yeni bir mektup geldi",
  "Taken: it is in your bag": "Alındı: çantanda",
  "Take what came with the letter first": "Önce mektupla gelenleri al",
  Feedback: "Geri bildirim",
  "Bug or idea": "Hata ya da öneri",
  "Send feedback": "Geri bildirim gönder",
  Block: "Engelle",
  Unblock: "Engeli kaldır",
  Report: "Şikayet et",
  "Report {name}": "{name} adlı oyuncuyu şikayet et",
  "What did they do? Abuse in chat, cheating, an offensive name...":
    "Ne yaptı? Sohbette hakaret, hile, rahatsız edici bir isim...",
  "Block on their frame hides their messages from you at once.":
    "Çerçevesindeki Engelle düğmesi mesajlarını hemen senden gizler.",
  "The team reads every message": "Ekip her mesajı okur",
  Bug: "Hata",
  Idea: "Öneri",
  Other: "Diğer",
  "What happened, and what did you expect?": "Ne oldu, sen ne bekliyordun?",
  "What would make the game better for you?": "Oyunu senin için ne daha iyi yapardı?",
  "Tell us anything.": "Aklındaki her şeyi yaz.",
  "Picture of the game view": "Oyun görüntüsünün resmi",
  "Sent with your message: tap to leave it out": "Mesajınla gönderilir: çıkarmak için dokun",
  "Left out: tap to send it": "Çıkarıldı: göndermek için dokun",
  "Your character, where you stand, your device and browser go with it, so we can find the problem.":
    "Sorunu bulabilmemiz için karakterin, bulunduğun yer, cihazın ve tarayıcın da gönderilir.",
  "Sending...": "Gönderiliyor...",
  Send: "Gönder",
  "Thank you! Your message reached the team.": "Teşekkürler! Mesajın ekibe ulaştı.",
  "You sent a lot of feedback just now: try again in a while.":
    "Az önce çok sayıda geri bildirim gönderdin: biraz sonra tekrar dene.",
  "It could not be sent. Check your connection and try again.":
    "Gönderilemedi. Bağlantını kontrol edip tekrar dene.",
  // ---- ui/clashWidget.ts, hud.ts: the Crystal Clash
  "Crystal Clash": "Kristal Çatışması",
  "Barred until {time}": "{time} saatine kadar katılamazsın",
  "Signed up": "Kaydoldun",
  GM: "GM",
  Join: "Katıl",
  Draw: "Berabere",
  "Victory!": "Zafer!",
  Defeat: "Yenilgi",
  "To Emberfold in {time}": "{time} içinde Emberfold'a",
  "First to {n} kills, or break the crystal":
    "{n} öldürmeye ilk ulaşan ya da kristali kıran kazanır",
  "Leave now?": "Şimdi ayrılıyor musun?",
  "Click the gate again to leave the Crystal Clash":
    "Kristal Çatışması'ndan ayrılmak için kapıya tekrar tıkla",
  "Click the gate again to leave: you will be barred for {n} hours":
    "Ayrılmak için kapıya tekrar tıkla: {n} saat boyunca katılamayacaksın",
  "Leave? You will be barred for {n} hours": "Ayrılıyor musun? {n} saat boyunca katılamayacaksın",
  "Crystal Clash sign-up is not open now": "Kristal Çatışması kayıtları şu an kapalı",
  "Your nation's side of this Crystal Clash is full":
    "Bu Kristal Çatışması'nda ulusunun tarafı dolu",
  "You left the Crystal Clash early too often: you may not join it yet":
    "Kristal Çatışması'ndan çok sık erken ayrıldın: henüz katılamazsın",
  "Game masters do not play in the Crystal Clash":
    "Oyun yöneticileri Kristal Çatışması'nda oynamaz",
  "Another character of your account is signed up already":
    "Hesabındaki başka bir karakter zaten kaydoldu",
  "The Crystal Clash is for levels {min} to {max}":
    "Kristal Çatışması {min} ile {max} seviyeleri içindir",
} satisfies Record<string, string>;
